<template>
    <div class="radio-inputs">
        <div v-for="(option, index) in options" :key="index" class="radio-input-wrap">
            <label class="radio">
                <input type="radio" :name="name" v-model="form[name]" :value="option.value" :checked="option.value === form[name]" />
                <span class="name">{{ option.name }}</span>
            </label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CustomCheckBox',
    props: {
        options: {
            type: Array,
            required: true
        },
        form: {
            type: Object,
            required: true
        },
        name: {
            type: String,
            required: true
        }
    }
};
</script>

<style scoped>
.radio-inputs {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #eee;
    box-sizing: border-box;
    padding: 10px 10px;
    width: max-content;
    font-size: 18px;
}

.radio-inputs .radio {
    flex: 1 1 auto;
    text-align: center;
}
.radio-input-wrap {
    margin-right: 5px;
}
.radio-input-wrap:last-child {
    margin-right: 0;
}

.radio-inputs .radio input {
    display: none;
}

.radio-inputs .radio .name {
    cursor: pointer;
    background-color: #eee;
    color: #333;
    transition: all 0.15s ease-in-out;
    padding: 8px 25px;
    font-weight: 300;
    font-size: 18px;
}

.radio-inputs .radio input:checked + .name {
    background-color: #eb0c2a;

    color: #fff;
    padding: 8px 25px;
}
.radio-inputs label {
    margin-bottom: 0px;
}
</style>
